import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
      },
      generalContainer: {},
      infoContainer: {
        marginTop: 24,
        paddingHorizontal: 30,
        marginHorizontal: 30,
        backgroundColor: props.colors.white,
        borderRadius: 20,
        borderWidth: 1,
        borderColor: props.colors.extraLight,
      },

      inputView: {
        flexDirection: 'row',
        gap: 200,
        paddingBottom: 54,
      },

      groupHeaderContainer: {
        width: '100%',
        height: 146,
        marginVertical: 24,
        borderBottomWidth: 1,
        borderBottomColor: props.colors.extraLight,
      },

      groupHeaderTextStyle: {
        fontSize: 18,
        ...props.typography.mulishBold,
      },

      listContainer: {
        flex: 1,
        maxWidth: 1160,
        flexDirection: 'row',
      },
      buttonContainer: {
        alignSelf: 'flex-end',
        marginBottom: 50,
      },

      bottomViewButtonContainer: {
        flexDirection: 'row',
        gap: 27,
        paddingBottom: 30,
      },

      cancelButtonStyle: {
        backgroundColor: props.colors.lightPurple,
        width: 308,
        height: 52,
      },

      cancelButtonTextColor: {
        color: props.colors.cornflowerBlue
      },

      secondButtonTextColor: {
        color: props.colors.white
      },

      secondButtonStyle: {
        backgroundColor: props.colors.cornflowerBlue,
        width: 308,
        height: 52,
      },
    },
    {
      [maxSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        secondButtonStyle: {
          width: 200,
        },
        cancelButtonStyle: {
          width: 200,
        },
      }
    },
  )();
